import { useNavigate } from "react-router-dom";
import styles from "./BackButton.module.scss";
import { ReactComponent as LEFT_ARROW_ICON } from "../../assets/SVGs/arrowLeftIcon.svg";
import Button2 from "../Button2";


function BackButton(props) {
    const navigate = useNavigate();
    return (
      <Button2 white linkButton onClick={props.onClick ? props.onClick : () => navigate(-1)} className={styles.returnToSearch}>
        <LEFT_ARROW_ICON />
        <p className={styles.searchText}>Go Back</p>
      </Button2>
    );
}

export default BackButton;